
<template>
  <div class="progress" v-if="isloading">
    <div class="mask" :style="bgcImg"></div>
    <!-- <div class="loading">
      <div class="trends" :style="{ width: LNumber }"></div>
    </div> -->
    <div class="loading-pie">
      <div class="pie">
        <img :src="require('@/assets/img/img14.gif')" alt="" />
        <span class="loading-number">{{ LNumber }}</span>
      </div>
      <div class="loading-content">
        <p>三维数据正在加载中</p>
        <p>{{ loadingMsg }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isloading: true,
      LNumber: '0%',
      bgcImg: {
        background: 'linear-gradient(to bottom, #10231d, #406363)'
      },
      loadingMsg: '请耐心等待.',
      loadingInter: null
    }
  },
  props: {
    num: {
      type: Number,
      default: 0
    }
  },
  watch: {
    num: function () {
      this.LNumber = this.num + '%'
      if (this.num >= 100)
        setTimeout(() => {
          this.isloading = false
          clearInterval(this.loadingInter)
        }, 1000)
    }
  },
  mounted() {
    console.log('num', this.num)
    var i = 1
    this.loadingInter = setInterval(() => {
      if (i >= 3) {
        this.loadingMsg = '请耐心等待.'
        i = 1
      } else {
        this.loadingMsg += '.'
        i++
      }
    }, 500)
  }
}
</script>
<style lang="scss" scoped>
/* 进度条 */
.progress {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.6);
    background-color: #000;
    background-size: cover;
    z-index: 99;
  }
  .loading {
    max-width: 96%;
    width: 20em;
    height: 0.5em;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    border-radius: 0.5em;
  }
  .loading-pie {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    text-align: center;
    .pie {
      width: 100px;
      height: 100px;
      margin: 0 auto;
      position: relative;
      img {
        width: 100px;
        height: 100px;
      }
      .loading-number {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        // color: #18161d;
        color: #fff;
        font-size: 20px;
        // font-weight: bold;
        font-family: 'Microsoft YaHei';
        text-align: center;
      }
    }

    .loading-content {
      font-size: 16px;
      margin-top: 20px;
      color: #be9b6e;
    }
  }
  .trends {
    width: 0;
    height: 100%;
    background: rgba(191, 122, 47, 1);
    border-radius: 0.5em;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/index.vue